/**
 * Centralised reads/writes for the persisted school selection used by the
 * ABC SE storefront. Keeps the localStorage shape consistent across pages.
 *
 * Stored shape:
 *   {
 *     school:  { id, slug, name, city },
 *     class:   string | null,
 *     savedAt: number,   // ms epoch — 24h freshness stamp (schoolSelectionTtl)
 *   }
 */

import { stampSchoolSelection, readFreshSelection, notifySchoolSelectionUpdated } from './schoolSelectionTtl';

const STORAGE_KEY = 'abcse_school_selection';

export function getSchoolSelection() {
  // Enforces the 24h TTL and clears expired/legacy (unstamped) entries.
  const parsed = readFreshSelection(STORAGE_KEY);
  return parsed && typeof parsed === 'object' ? parsed : null;
}

export function setSchoolSelection(selection) {
  if (!selection || !selection.school) {
    clearSchoolSelection();
    return;
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(stampSchoolSelection({
    school: {
      id: selection.school.id,
      slug: selection.school.slug,
      name: selection.school.name,
      city: selection.school.city ?? null,
    },
    class: selection.class ?? null,
  })));
  notifySchoolSelectionUpdated(STORAGE_KEY);
}

export function clearSchoolSelection() {
  localStorage.removeItem(STORAGE_KEY);
  notifySchoolSelectionUpdated(STORAGE_KEY);
}

export const SCHOOL_STORAGE_KEY = STORAGE_KEY;
